const SettingsType = {
  SHOW_CALENDAR_SETTINGS: "SHOW_CALENDAR_SETTINGS",
  SHOW_GANTT_SETTINGS: "SHOW_GANTT_SETTINGS",
  SHOW_FILES_SETTINGS: "SHOW_FILES_SETTINGS",
  SHOW_CONCEPT_SETTINGS: "SHOW_CONCEPT_SETTINGS",
  SHOW_NOTES_SETTINGS: "SHOW_NOTES_SETTINGS",
};

export default SettingsType;
